import { render, staticRenderFns } from "./DescriptionDetails.vue?vue&type=template&id=39008b40"
import script from "./DescriptionDetails.vue?vue&type=script&lang=js"
export * from "./DescriptionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports